<template>
    <b-overlay
      :show="mostrarLoader"
      opacity="0.50"
      rounded="sm"
      spinner-variant="primary"
      spinner-type="grow"
    >
        <b-card class="div-with-loading vs-con-loading__container">
            <b-row>
                <b-col cols="12">
                    <b-form-group>
                        <label class="text-sm"><span class="text-danger">*</span> Nombre</label>
                        <b-input
                            label="Nombre"
                            v-model="item.nombre"
                            class="required w-full"
                            v-validate="'required|max:50'"
                            :danger="errors.has('nombre')"
                            name="nombre"
                            placeholder="Ingrese nombre"
                            maxlength="50"
                            :class="[{'is-invalid': errors.has('nombre')}]"
                        />
                        <span class="text-danger text-sm" v-show="errors.has('nombre')">{{  errors.first('nombre') }}</span>
                    </b-form-group>
                </b-col>

                <b-col lg="6" md="12">
                    <el-form>
                        <el-form-item class="vx-col w-full">
                            <label><span class="text-danger">*</span> Tipo</label>
                            <el-select :options="item_choice.tipo" v-model="item.tipo">
                                <el-option
                                    v-for="item in item_choice.tipo"
                                    :key="item.id"
                                    :label="item.text"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                </b-col>

                <b-col lg="6" md="12">
                    <el-form>
                        <el-form-item class="vx-col w-full">
                            <label><span class="text-danger">*</span> Módulo</label>
                            <el-select :options="item_choice.modulo" v-model="item.modulo">
                                <el-option
                                    v-for="item in item_choice.modulo"
                                    :key="item.id"
                                    :label="item.text"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                </b-col>

                <b-col lg="6" md="12">
                    <b-form-group>
                        <label class="text-sm"><span class="text-danger">*</span> Límite</label>
                        <b-input
                            label="Límite"
                            v-model="item.limite"
                            class="required w-full"
                            v-validate="'required|numeric'"
                            :danger="errors.has('limite')"
                            name="limite"
                            data-vv-as="límite"
                            placeholder="Ingrese límite"
                            maxlength="50"
                            :class="[{'is-invalid': errors.has('limite')}]"
                        />
                        <span class="text-danger text-sm" v-show="errors.has('limite')">{{  errors.first('limite') }}</span>
                    </b-form-group>
                </b-col>

                <b-col lg="6" md="12">
                      <b-form-group>
                          <label class="text-sm"><span class="text-danger">*</span> Precio</label>
                          <b-input-group
                            prepend="$"
                          >
                              <b-form-input
                                icon-pack="feather"
                                icon="icon-dollar-sign"
                                label="Precio"
                                v-model="item.precio"
                                class="required w-full"
                                v-validate="'required'"
                                :danger="errors.has('precio')"
                                name="precio"
                                placeholder="Ingrese precio"
                                :class="[{'is-invalid': errors.has('precio')}]"
                              />
                          </b-input-group>
                          <span class="text-danger text-sm" v-show="errors.has('precio')">{{  errors.first('precio') }}</span>
                      </b-form-group>
                </b-col>
            </b-row>

            <div class="text-center">
                <b-button id="button-with-loading" variant="primary" class="mt-2 vs-con-loading__container" v-on:click="submitFormItem">Guardar</b-button>
            </div>
        </b-card>
    </b-overlay>
</template>

<script>
import axios from '@/axios'
import vSelect from 'vue-select'
import { Validator } from 'vee-validate';
import es from 'vee-validate/dist/locale/es'
import ToastificationContent from "@core/components/toastification/ToastificationContent";

Validator.localize("es", es);

export default {
    data() {
        return {
            item: {
                nombre: '',
                tipo: 'BAS',
                modulo: 'USU',
                limite: '',
                precio: '',
                // empresa: this.$store.state.token_empresa
            },

            input_prop: {
                nombre:         {danger: false, dangertext: ''},
                limite:         {danger: false, dangertext: ''},
                precio:         {danger: false, dangertext: ''},
            },
            item_choice:{
                tipo:[
                    {id: 1, text: 'Base', value:'BAS'},
                    {id: 2, text: 'Adicional', value:'ADI'}
                ],
                modulo:[
                    {id: 3, text: 'Usuario', value:'USU'},
                    {id: 4, text: 'Almacenamiento', value:'ALM'},
                    {id: 5, text: 'Trámite', value:'TRA'},
                ],
            },
            mostrarLoader: false,
        }
    },
    methods: {
        createItem: function (e) {
            this.openLoadingInDiv();
            axios.post('api/plan/registrar-item/', {data_item:this.item}).then(response =>{
                this.closeLoadingInDiv();
                this.$router.push('/administrador/items/editar/' + response.data.data.token_publico);
            })
            .catch(error => {
                this.closeLoadingInDiv();
                // console.log(error);
            });
        },

        updateItem: function (e) {
            this.openLoadingInDiv()
            axios.put(`api/item/${this.$route.params.token_publico}/`,
              this.item
            )
            .then(response => {
                this.closeLoadingInDiv()
                this.showToast()
            })
            .catch(error => {
                this.closeLoadingInDiv()
            });
        },

        submitFormItem: function(){
            this.openLoadingInDiv();
            this.$validator.validateAll().then(result => {
                if (result) {
                    // if form have no errors
                    if (this.estaEnModoEdicion){
                        this.updateItem()
                    }
                    else{
                        this.createItem()
                    }
                } else {
                    this.closeLoadingInDiv();
                }
            });
        },

        openLoadingInDiv(){
            this.mostrarLoader = true
        },
        closeLoadingInDiv(){
            this.mostrarLoader = false
        },

        cargarItem() {
            this.openLoadingInDiv();
            axios.get('api/item/' + this.$route.params.token_publico)
            .then( response => {
                this.item = response.data;
                this.closeLoadingInDiv();
            });
        },

        showToast() {
          this.$toast.success({
            component: ToastificationContent,
            props: {
              title: 'Ítem',
              icon: 'SaveIcon',
              text: 'Cambios Guardados correctamente',
            },
          },
          {
            position: 'bottom-right',
          })
        },
    },
    mounted () {
      if(this.estaEnModoEdicion){
        this.cargarItem();
        this.all();
      }
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            if(from.name=="RegistrarItem"){
                vm.showToast();
            };
        });
      },
    computed: {
        estaEnModoEdicion(){
            if (this.$route.params.token_publico){
              return true
            }
            else{
              return false
            }
        }
    },
}
</script>

<style>
    .required > .vs-input--label::before{
        content: "* ";
        color: #F56C6C;
    }

    .el-select{
        display: block!important;
    }
</style>
